var NotificationModalComponent = require("./notification-modal.component");
var NotificationPaneComponent = require("./notification-pane.component");

var NotificationPanesService = function () {
    var STORAGE_KEY_NOTIFICATIONS = "User.Notifications";

    var $currentContext = $();
    var moduleOptions = {};

    var panesList = [];

    function markAsClosed(pane) {
        var storage = pane.permanentClose() ? localStorage : sessionStorage;
        var closedPanesList = getClosedPanesList(storage);
        closedPanesList.push(pane.id());
        storage.setItem(STORAGE_KEY_NOTIFICATIONS, JSON.stringify(closedPanesList));
    }

    function isClosedPane(paneId) {
        var closedPanesList = getClosedPanesList(localStorage).concat(getClosedPanesList(sessionStorage));
        var closedPaneIndex = closedPanesList.indexOf(paneId);

        return closedPaneIndex > -1;
    }

    function getClosedPanesList(storage) {
        var closedPanesValue = storage.getItem(STORAGE_KEY_NOTIFICATIONS);
        return !!closedPanesValue ? JSON.parse(closedPanesValue) : [];
    }

    function showPanes() {
        panesList.forEach(pane => {
            if (!isClosedPane(pane.id())) {
                pane.show();
            }
        });
    }

    function bindEvents() {
        panesList.forEach(pane => {
            pane.on("close", function () {
                markAsClosed(pane);
            });
        });
    }

    function parseContext() {
        var $panes = $(NotificationPaneComponent.SELECTOR, $currentContext);
        $panes.each((index, entry) => {
            var $paneContext = $(entry);
            var pane = new NotificationPaneComponent();
            pane.init($paneContext);
            panesList.push(pane);
        });

        // var $modal = $(NotificationModalComponent.SELECTOR, $currentContext);
        // if ($modal.length){
        //     var pane = new NotificationModalComponent();
        //     pane.init($modal);
        //     panesList.push(pane);
        // }
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);
        console.log("test 1");
        parseContext();
        bindEvents();
        showPanes();
    };

    return this;
};

module.exports = NotificationPanesService;
